import { useParkingSpaceContracts } from './useParkingSpaceContracts';

export const useParkingContract = (contractId: string | null | undefined) => {
  const { all: allParkingContracts, isLoading } = useParkingSpaceContracts();

  return {
    parkingContract: allParkingContracts.find(
      (parkingSpaceContract) =>
        parkingSpaceContract.parkingContractId === contractId
    ),
    isLoading,
  };
};
